import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { exportToExcel } from "./exportToExcel";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { getCompanies as getCompaniesAction } from "../../../store/actions/Companies/companyActions";
import { dateFormat } from "../../../utils/date";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del } from "../../../services/api";
import { getLoggenInToken,getLoggedInUser } from "../../../store/selectors/AuthSelectors";
import SendEmail from "../Common/SendEmail"
import SendLetter from "../Common/SendLetter"
import Status from "../Common/Status";
import { getCompanies } from "../../../store/selectors/Companies/CompaniesList";

const ListTab = ({ title, companies, token,loggedInUser }) => {
  const userdata = useRef();
  const sendletterref = useRef();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [selectedCompany, setSelectedCompany] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPage = 10;

  // Filtered companies based on search term
  

  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  //const records = filteredCompanies.slice(firstIndex, lastIndex);
  const npage = Math.ceil(companies.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [expandedCompanies, setExpandedCompanies] = useState({});

const toggleExpand = (companyId) => {
  setExpandedCompanies((prev) => ({
    ...prev,
    [companyId]: !prev[companyId],
  }));
};

  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }

  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);

  useEffect(() => {
    setChecked(
      
      companies?.slice(firstIndex, lastIndex).map((candidate) => ({
        ...candidate,
        inputchecked: false,
      }))
    );
  }, [companies, currentPage])

  useEffect(() => {
    const filteredCompanies = companies.filter(
      (company) =>
        company.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        company.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setChecked(filteredCompanies);
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(1); // Reset to first page on data update
  }, [companies, searchTerm]);

  const handleChecked = (id) => {
    console.log("id", id);
    setChecked((prevChecked) => {
      return prevChecked.map((company) => {
        if (company._id === id) {
          const newCheckedState = !company.inputchecked;
            return { 
            ...company, 
            inputchecked: newCheckedState,
            childCompanies: company.childCompanies?.map(child => ({
              ...child,
              inputchecked: newCheckedState
            }))
          };
        } 
        if (company.childCompanies) {
          return {
            ...company,
            childCompanies: company.childCompanies.map(child =>
              child._id === id ? { ...child, inputchecked: !child.inputchecked } : child
            ),
          };
        }
        return company;
      });
    });
  };
  

  const handleCheckedAll = (value) => {
    let temp = checked.map((data) => {
      return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!unchecked);
  };


  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption d-flex justify-content-between align-items-center">
              <h4 className="heading mb-0">{title}</h4>
              <div>
              <button className="btn btn-primary btn-sm me-2" 
                        onClick={()=> userdata.current.showEmailModal()}
                        disabled={checked.filter(d => d.inputchecked || d.childCompanies?.some(child => child.inputchecked))?.length === 0}
                        >
                        <i className="fa-solid fa-envelope me-2"></i>
                          Send Mail
                        </button>
                        <button className="btn btn-primary btn-sm me-2" 
                        onClick={()=> sendletterref.current.showLetterModal()}
                        disabled={checked.filter(d => d.inputchecked || d.childCompanies?.some(child => child.inputchecked))?.length === 0}
                        >
                        <i className="fa-solid fa-envelope me-2"></i>
                          Send Letter
                        </button>
                <button
                  onClick={() =>
                    exportToExcel(
                      checked.filter((itm) => itm.inputchecked).length > 0
                        ? checked.filter((itm) => itm.inputchecked)
                        : companies
                    )
                  }
                  className="btn btn-primary light btn-sm"
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </button>
                      
              </div>
            </div>
            <div className="p-2">
              <input
                type="text"
                placeholder="Search by Company Name or Email"
                className="form-control form-control-sm me-2 w-50"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "300px" }}
              />
            </div>
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th className="sorting_asc_11">
                      <div className="form-check custom-checkbox ms-0">
                        <input
                          type="checkbox"
                          className="form-check-input checkAllInput"
                          onClick={() => handleCheckedAll(unchecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkAll"
                        ></label>
                      </div>
                    </th>
                    <th>Company Name</th>
                    <th>Registration No.</th>
                    <th>Email</th>
                    <th>Reg Date</th>
                    <th>Reg End Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                  {checked.map((item, index) => (
                    <>
                    <tr key={index}>
                      <td>
                <button onClick={() => toggleExpand(item._id)} className="btn btn-link">
                  {expandedCompanies[item._id] ? <i className="bi bi-chevron-down"></i> : <i className="bi bi-chevron-right"></i>}
                </button>
              </td>
                      <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={item.inputchecked}
                            onChange={() => handleChecked(item._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <p className="mb-0 ms-2">{item.companyName}</p>
                        </div>
                      </td>
                      <td>{item.companyRegNo}</td>
                      <td>{item.email}</td>
                      <td>{dateFormat(item.regDate)}</td>
                      <td>{dateFormat(item.regEndDate)}</td>
                      <td>
                        <Status status={item.status} />
                      </td>
                      <td>
                        <div className="action-icons">
  {/* View Icon */}
  <button 
    className="btn btn-link" 
    onClick={() => nav(`/add-company?id=${item._id}&mode=view`)}
    title="View"
  >
   <i class="bi bi-eye"></i>
  </button>

  {/* Edit Icon */}
  <button 
    className="btn btn-link" 
    onClick={() => nav(`/add-company?id=${item._id}&mode=edit`)}
    title="Edit"
  >
    <i class="bi bi-pen"></i>
  </button>

  {/* Delete Icon */}
  <button 
    className="btn btn-link text-danger" 
    onClick={(e) => {
      e.preventDefault();
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this company!",
        icon: "warning",
        buttons: true,
        confirmButtonText: "Delete",
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await del(`/api/company/${item?._id}`, token);
          toast.success("Company deleted successfully.");
          dispatch(getCompaniesAction(token));
        }
      });
    }}
    title="Delete"
  >
    <i class="bi bi-trash"></i>
  </button>
</div>

                      </td>
                    </tr>
                    {expandedCompanies[item._id] &&
                item.childCompanies?.map((child, childIndex) => (
                  <tr key={childIndex}>
                    <td></td>
                    <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={child.inputchecked}
                            onChange={() => handleChecked(child._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                    <td className="ps-4">{child.companyName}</td>
                    <td>{child.companyRegNo}</td>
                    <td>{child.email}</td>
                    <td>{dateFormat(child.regDate)}</td>
                    <td>{dateFormat(child.regEndDate)}</td>
                    <td><Status status={child.status} /></td>
                    <td>
                      <div className="action-icons">
                        <button className="btn btn-link" onClick={() => nav(`/add-company?id=${child._id}&mode=view`)} title="View">
                          <i className="bi bi-eye"></i>
                        </button>
                        <button className="btn btn-link" onClick={() => nav(`/add-company?id=${child._id}&mode=edit`)} title="Edit">
                          <i className="bi bi-pen"></i>
                        </button>
                        <button
                          className="btn btn-link text-danger"
                          onClick={(e) => {
                            e.preventDefault();
                            swal({
                              title: "Are you sure?",
                              text: "Once deleted, you will not be able to recover this company!",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then(async (willDelete) => {
                              if (willDelete) {
                                await del(`/api/company/${child._id}`, token);
                                toast.success("Company deleted successfully.");
                                dispatch(getCompaniesAction(token));
                              }
                            });
                          }}
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  ))}
                  </>
                  ))}
                  </>
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                Showing {lastIndex - recordsPage + 1} to {companies.length} of{" "}
                {companies.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers justify-content-center"
                  id="example2_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="#"
                    onClick={prePage}
                  >
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${
                          currentPage === n ? "current" : ""
                        } `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={nextPage}
                  >
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SendEmail ref={userdata} Title="Send Email" 
        token={token} 
        data={checked.filter(d=>d.inputchecked)} 
        isCompany={true}
        user={loggedInUser}
        //hint={"Please use #title#, #firstName# , #lastName# to dynamically map values"}
      />
      <SendLetter 
      ref={sendletterref}
      data={checked.filter(d=>d.inputchecked)}
      isCompany={true}
      token={token} 
      user={loggedInUser}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: getCompanies(state),
    token: getLoggenInToken(state),
    loggedInUser: getLoggedInUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(ListTab));
